<template>
  <DropdownSelector
    @change="onInput"
    :value="selectedCategory?.id"
    :options="categories"
    :iconType="'material'"
    :iconName="selectedCategory?.icon ?? 'sell'"
    :iconColor="selectedCategoryColor"
    :label="t('admin.search.filters.category')"
    :disabled="disabled"
    :horizontalLabelWidth="horizontalLabelWidth"
    :emptyLabel="t('components.inputs.category.empty')"
    :hint="hint"
  />
</template>

<script setup>
import { computed, defineEmits, defineProps, ref, watch } from "vue";
import { useTenantCategories } from "@/Tailwind/Mixins/useCategories";
import DropdownSelector from "@/Tailwind/Components/Input/DropdownSelector.vue";

import { useI18n } from "vue-i18n";
const { t } = useI18n();

const props = defineProps({
  tenantId: String,
  categoryId: String,
  disabled: Boolean,
  horizontalLabelWidth: {
    type: String,
    default: "0rem",
  },
  hint: String,
});

const selectedCategoryColor = computed(() => ({
  "text-pink-500": selectedCategory.value?.color === "#F3407F",
  "text-yellow-500": selectedCategory.value?.color === "#864817",
  "text-gray-500": selectedCategory.value?.color === "#676C75",
  "text-amber-500": selectedCategory.value?.color === "#ffa000",
  "text-zinc-500": selectedCategory.value?.color === "#2C2C2C",
  "text-cyan-500": selectedCategory.value?.color === "#00bcd4",
  "text-sky-500": selectedCategory.value?.color === "#2196f3",
  "text-slate-500": selectedCategory.value?.color === "#607d8b",
  "text-stone-500": selectedCategory.value?.color === "#795546",
  "text-fuchsia-500": selectedCategory.value?.color === "#9c27b0",
  "text-orange-500": selectedCategory.value?.color === "#ff9800",
  "text-blue-500": selectedCategory.value?.color === "#2368ff",
  "text-green-500": selectedCategory.value?.color === "#2bbd38",
}));

const _categoryId = ref(props.categoryId);

const selectedCategory = computed(() => {
  return categories.value.find((category) => {
    return category?.id === _categoryId.value;
  });
});

const onInput = (value) => {
  // Update the internal selected category to show the correct icon
  _categoryId.value = value === _categoryId.value ? null : value;
  emit("change", value);
};

const emit = defineEmits(["change"]);

watch(
  () => props.categoryId,
  (value) => {
    _categoryId.value = value;
  }
);

const categories = computed(() => {
  return useTenantCategories(props.tenantId);
});
</script>
